import { type FC } from 'react';
import styled from 'styled-components';

import { useUserLocale } from '@/i18n/hooks';

interface Props {
  value: number;
  description: string;
  unit?: string;
}

export const EsgValueListItem: FC<Props> = ({ value, description, unit }) => {
  const locale = useUserLocale();

  return (
    <Container>
      <dt>{description}</dt>
      <dd>{`${value.toLocaleString(locale)}${unit}`}</dd>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  border-bottom: 1px solid var(--p-color-stroke-subtle-0);
  padding: 12px;

  dt {
    flex: 1;
  }
`;
